/**
 * Final Optimized Variant Filter
 * Clean, efficient implementation with perfect desktop and mobile experience
 */
if (!customElements.get('variant-media-filter')) {
  customElements.define('variant-media-filter', class extends HTMLElement {
    constructor() {
      super();
      
      // Add CSS for transitions
      const style = document.createElement('style');
      style.textContent = `
        .filtered-variant {
          display: none !important;
        }
        
        /* Desktop transitions */
        @media screen and (min-width: 750px) {
          .media-fade-active .product__media-list,
          .media-fade-active .product__media-gallery {
            opacity: 0 !important;
            transition: opacity 0.05s linear !important;
          }
          
          .product__media-list,
          .product__media-gallery {
            opacity: 1;
            transition: opacity 0.25s ease-in !important;
          }
          
          /* Completely hide thumbnails during transition */
          .thumbnail-toggle-hidden {
            display: none !important;
          }
        }
        
        /* Mobile transitions */
        @media screen and (max-width: 749px) {
          .media-fade-active .product__media-list,
          .media-fade-active .product__media-gallery,
          .media-fade-active .thumbnail-list {
            opacity: 0 !important;
            transition: opacity 0.15s ease-out !important;
          }
          
          .product__media-list,
          .product__media-gallery,
          .thumbnail-list {
            opacity: 1;
            transition: opacity 0.25s ease-in !important;
          }
        }
      `;
      document.head.appendChild(style);
      
      this.currentVariant = '';
      this.isChanging = false;
    }
    
    connectedCallback() {
      this.setup();
    }
    
    setup() {
      // Filter media initially
      this.filterMedia(true);
      
      // Listen for variant changes
      document.addEventListener('variant:changed', () => this.handleVariantChange());
      document.addEventListener('change', e => {
        // Skip quantity inputs
        if (e.target.closest('.quantity__input') || e.target.closest('[name="quantity"]')) return;
        
        if (e.target.closest('.product-form__input')) {
          this.handleVariantChange();
        }
      });
    }
    
    handleVariantChange() {
      // Prevent multiple rapid changes
      if (this.isChanging) return;
      this.isChanging = true;
      
      // Check if on mobile
      const isMobile = window.innerWidth < 750;
      
      // For desktop, directly hide thumbnails before any transition
      if (!isMobile) {
        this.toggleThumbnails(false);
      }
      
      // Add fade class to body
      document.body.classList.add('media-fade-active');
      
      // Different timing for desktop vs mobile
      const fadeOutTime = isMobile ? 150 : 50;
      
      // Filter media after fade-out completes
      setTimeout(() => {
        this.filterMedia();
        this.resetSliderToFirstSlide();
        
        // Wait before fade-in
        setTimeout(() => {
          document.body.classList.remove('media-fade-active');
          
          // For desktop, restore thumbnails after a delay
          if (!isMobile) {
            setTimeout(() => {
              this.toggleThumbnails(true);
              this.isChanging = false;
            }, 100);
          } else {
            this.isChanging = false;
          }
        }, isMobile ? 100 : 50);
      }, fadeOutTime);
    }
    
    toggleThumbnails(show) {
      document.querySelectorAll('.thumbnail-list').forEach(list => {
        list.classList.toggle('thumbnail-toggle-hidden', !show);
      });
    }
    
    resetSliderToFirstSlide() {
      const slider = document.querySelector('slider-component');
      if (slider?.closest('.product') && typeof slider.resetPages === 'function') {
        slider.resetPages();
      }
    }
    
    filterMedia(isInitial = false) {
      // Get selected variant
      const variant = this.getSelectedVariant();
      if (!variant) return;
      
      // Normalize variant
      const normalizedVariant = variant.toLowerCase().replace(/\s+/g, '-');
      
      // Skip if unchanged and not initial
      if (this.currentVariant === normalizedVariant && !isInitial) return;
      this.currentVariant = normalizedVariant;
      
      // Filter media items
      document.querySelectorAll('.product__media-item').forEach(item => {
        const group = item.getAttribute('data-variant-group');
        if (!group) return;
        
        const shouldShow = group === 'all' || group === normalizedVariant;
        item.classList.toggle('filtered-variant', !shouldShow);
      });
      
      // Filter thumbnails
      document.querySelectorAll('.thumbnail-list__item').forEach(thumb => {
        const targetId = thumb.getAttribute('data-target');
        if (!targetId) return;
        
        const targetMedia = document.querySelector(`.product__media-item[data-media-id="${targetId}"]`);
        const isFiltered = mediaItem => mediaItem?.classList.contains('filtered-variant') || false;
        
        thumb.classList.toggle('filtered-variant', isFiltered(targetMedia));
      });
    }
    
    getSelectedVariant() {
      return (
        document.querySelector('.product-form__input select')?.value ||
        document.querySelector('.product-form__input input[type="radio"]:checked')?.value ||
        document.querySelector('variant-selects [data-selected-value]')?.textContent?.trim() ||
        null
      );
    }
  });
  
  // Initialize immediately
  document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('variant-media-filter')) {
      document.body.appendChild(document.createElement('variant-media-filter'));
    }
  });
}